import { useState } from "react";
import Modal1 from "./Modal1.modal";
import Modal2 from "./Modal2.modal";
import Modal3 from "./Modal3.modal";
import { useNavigate } from "react-router-dom";
import { URLS } from "../../_config";

const RegisterModal = () => {
    const navigate = useNavigate();
    const [showModal1, setShowModal1] = useState(true);
    const [showModal2, setShowModal2] = useState(false);
   // const [showModal3, setShowModal3] = useState(false);

    const handleShowModal1 = () => {
        setShowModal1(false);
        setShowModal2(true);
    }
    const handleShowModal2 = () => {
        setShowModal2(false);
        navigate(URLS.HOME)

    }
    // const handleShowModal3 = () => {
    //     setShowModal3(false);
    // }
    return <>
        <div className="login_page">

            <div className="login_right" data-aos="fade-left"></div>
        </div>
        <Modal1 show={showModal1} onClose={() => handleShowModal1()} />
        <Modal2 show={showModal2} onClose={() => handleShowModal2()} />
        {/* <Modal3 show={showModal3} onClose={() => handleShowModal3()} /> */}


         
 

 
    </>
}
export default RegisterModal;